import React from 'react';
import LoginForm from './LoginForm';
import RegisterForm from './RegisterForm';
import ForgotPasswordForm from './ForgotPasswordForm';

const TABS = [
  ['login',    'Iniciar sesión'],
  ['register', 'Registrarme'],
  ['forgot',   '¿Olvidaste?'],
];

export default function AuthPage({ toast, auth }) {
  const {
    authMode, setAuthMode,
    loginForm, setLoginForm,
    regForm, setRegForm,
    forgotEmail, setForgotEmail,
    resetForm, setResetForm,
    showPassword, setShowPassword,
    showRegisterPassword, setShowRegisterPassword,
    showRegisterConfirmPassword, setShowRegisterConfirmPassword,
    hcaptchaSiteKey, captchaEnabled, captchaResetCounter,
    captchaLoading, refreshCaptcha, handleCaptchaVerify, handleCaptchaExpire, handleCaptchaError,
    states, municipalities, cees,
    catalogLoading, municipalitiesLoading,
    handleLogin, handleRegister, handleForgot, handleReset,
  } = auth;

  return (
    <div className="login-shell">
      {toast && <div className={`toast toast-${toast.type}`}>{toast.msg}</div>}

      <div className="login-card">
        <div className="brand">
          <span className="brand-morena">morena</span>
          <span className="brand-sub">La esperanza de México</span>
        </div>
        <h2 className="login-title">
          Asambleas Informativas por la<br />Defensa de la Soberanía Nacional
        </h2>

        <div className="auth-tabs">
          {TABS.map(([mode, label]) => (
            <button
              key={mode}
              className={authMode === mode ? 'active' : ''}
              onClick={() => setAuthMode(mode)}
            >
              {label}
            </button>
          ))}
        </div>

        {authMode === 'login' && (
          <LoginForm
            form={loginForm}
            onChange={setLoginForm}
            onSubmit={handleLogin}
            showPassword={showPassword}
            onTogglePassword={() => setShowPassword(p => !p)}
          />
        )}

        {authMode === 'register' && (
          <RegisterForm
            form={regForm}
            onChange={setRegForm}
            onSubmit={handleRegister}
            hcaptchaSiteKey={hcaptchaSiteKey}
            captchaEnabled={captchaEnabled}
            captchaLoading={captchaLoading}
            captchaResetCounter={captchaResetCounter}
            onCaptchaVerify={handleCaptchaVerify}
            onCaptchaExpire={handleCaptchaExpire}
            onCaptchaError={handleCaptchaError}
            onRefreshCaptcha={refreshCaptcha}
            states={states}
            municipalities={municipalities}
            cees={cees}
            catalogLoading={catalogLoading}
            municipalitiesLoading={municipalitiesLoading}
            showPassword={showRegisterPassword}
            onTogglePassword={() => setShowRegisterPassword((p) => !p)}
            showConfirmPassword={showRegisterConfirmPassword}
            onToggleConfirmPassword={() => setShowRegisterConfirmPassword((p) => !p)}
          />
        )}

        {authMode === 'forgot' && (
          <ForgotPasswordForm
            forgotEmail={forgotEmail}
            onForgotEmailChange={setForgotEmail}
            onForgotSubmit={handleForgot}
            resetForm={resetForm}
            onResetFormChange={setResetForm}
            onResetSubmit={handleReset}
          />
        )}
      </div>
    </div>
  );
}
